<template>
  <!--
    @name: topics.vue
    @description:
    @author:  XueRunBing
    @time: 2021/2/6 14:10
  -->
  <div class="article-topics">
      <div class="topics-img">
          <img :src="specialBasicsInfo.banner" alt="">
      </div>
      <!-- 专题介绍 -->
      <div class="topics-introduction" style="margin-bottom:-8px">
          <topics-title :title="specialBasicsInfo.title"></topics-title>
          <div class="intr-con">
              <div class="intr-info" v-if="specialBasicsInfo.content" v-html="specialBasicsInfo.content"></div>
              <div class="intr-banner" :style="carouselList.length > 1 ? '' : 'margin-bottom:10px'">
                  <van-swipe class="my-swipe" :autoplay="5000" indicator-color="black" >
                    <van-swipe-item v-for="(item,index) in carouselList" :key="index">
                        <img :src="item.image" alt="" @click="goReadOn(item.link_h5)">
                        <div class="title">{{ item.title }}</div>
                    </van-swipe-item>
                 </van-swipe>
              </div>
          </div>
      </div>

      <!-- 分类 -->
      <div class="classification common-swipe-style" v-for="(val,n) in classificationArr" :key="n" :style="val.list.length > 1 ? 'margin-bottom:-10px' : 'margin-bottom:10px'">
          <topics-title :title="val.title"></topics-title>
          <div class="classification-con">
            <div class="classification-swipe">
                <van-swipe class="my-swipe" :autoplay="5000" indicator-color="black">
                    <van-swipe-item v-for="(item,index) in val.list" :key="index">
                        <div class="classification-item" v-for="(v,i) in item" :key="i">
                            <div class="title">{{v.title}}</div>
                            <div class="content">
                                <span class="text">{{v.content | intercept}}</span>
                                <span class="more">
                                    <a target="_blank" class="a-more" to="" @click="goReadOn(v.link_h5)">继续阅读 ></a>
                                </span>
                            </div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
          </div>
      </div>
      <!-- 相关下载 -->
      <div   class="relevant common-swipe-style" >
          <topics-title :title="rollList[0] ? rollList[0].title : ''"></topics-title>
          <div class="relevant-con">
            <div class="relevant-swipe">
                 <van-swipe class="my-swipe" :autoplay="5000" indicator-color="black">
                    <van-swipe-item v-for="(item,index) in relevantList" :key="index">
                        <ul>
                            <li v-for="(v,i) in item" :key="i">
                                <span>
                                    <a target="_blank" to="" @click="goReadOn(v.link_h5)">
                                        {{v.title}}
                                    </a>
                                </span>
                            </li>
                        </ul>
                    </van-swipe-item>
                 </van-swipe>
            </div>
          </div>
      </div>

      <!-- 往期回顾 -->
      <div  :class="rollList[0] && rollList[0].list.length <= 5 ? 'relevant common-swipe-style m-t-10':'relevant common-swipe-style  m-t-f-10'">
        <topics-title :title="rollList[1] ? rollList[1].title : ''"></topics-title>
          <div class="relevant-con">
            <div class="relevant-swipe">
                 <van-swipe class="my-swipe" :autoplay="5000" indicator-color="black">
                    <van-swipe-item v-for="(item,index) in reviewList" :key="index">
                        <ul>
                            <li v-for="(v,i) in item" :key="i">
                                <span>
                                    <a target="_blank" to="" @click="goReadOn(v.link_h5)">
                                        {{v.title}}
                                    </a>
                                </span>
                            </li>
                        </ul>
                    </van-swipe-item>
                 </van-swipe>
            </div>
          </div>
      </div>

      <!-- 学习营 -->
      <div v-if="qrcodeList[0]" :class="rollList[1] && rollList[1].list.length <= 5 ? 'learning-camp learning-camp-top':'learning-camp'">
            <div class="content">
                <div class="qrcode">
                    <img :src="qrcodeList[0] ? qrcodeList[0].qrcode : ''" alt="">
                </div>
                <div class="info">
                    <div class="title">{{qrcodeList[0] ? qrcodeList[0].title : ''}}</div>
                    <div class="msg">{{qrcodeList[0] ? qrcodeList[0].content : ''}}</div>
                </div>
            </div>
      </div>

  </div>

</template>

<script>
import TopicsTitle from '../../components/Topics/TopicsTitle'
import {getArticleSpecialInfoApi} from '@/api/article'
export default {
  name: 'articleTopics',
  data () {
    return {
      specialId: this.$route.params.id,
      specialBasicsInfo: [],
      carouselList: [],
      rollList: [],
      relevantList: [],
      reviewList: [],
      classificationArr: [],
      qrcodeList: []
    }
  },
  components: {
    TopicsTitle
  },
  mounted () {
    this.getArticleSpecialInfo()
  },
  filters: {
    intercept (val) {
      return val.substr(0, 67)
    }
  },
  methods: {
    getArticleSpecialInfo () {
      getArticleSpecialInfoApi({ id: this.specialId }).then(res => {
        if (res.code === this.$config.codeOk) {
          this.specialBasicsInfo = res.data.base
          this.backgroundColor = res.data.base.color
          this.carouselList = res.data.introduce
          this.classificationList = res.data.data1
          // 将数据3个分成一组（二维数组转化成三维数组）
          var arr = res.data.data1
          var reault = []
          for (var j = 0; j < res.data.data1.length; j++) {
            reault = []
            for (var i = 0; i < res.data.data1[j].list.length; i += 3) {
              reault.push(res.data.data1[j].list.slice(i, i + 3))
            }
            arr[j].list = reault
          }

          this.classificationArr = arr
          this.rollList = res.data.data2
          this.qrcodeList = res.data.qrcode

          let relevantArr = []
          let chunk = 5 // 每5个分一组
          for (var n = 0, m = res.data.data2[0].list.length; n < m; n += chunk) {
            relevantArr.push(res.data.data2[0].list.slice(n, n + chunk))
          }
          this.relevantList = relevantArr

          let reviewvantArr = []
          let num = 5 // 每5个分一组
          for (var x = 0, y = res.data.data2[1].list.length; x < y; x += num) {
            reviewvantArr.push(res.data.data2[1].list.slice(x, x + num))
          }
          this.reviewList = reviewvantArr
        }
      }).catch(() => {

      })
    },
    goReadOn (link) {
      window.open(link)
    }
  }
}
</script>

<style lang="less" scoped>

.a-more{
 text-decoration:underline;
}
.article-topics {
    width: 100%;
    overflow: hidden;
    .topics-img{
        width: 100%;
        img{
            width: 100%;
        }
    }
    .topics-introduction{
      width: 100%;
      .intr-con{
         width: 100%;
         padding: 0 22px;
         box-sizing: border-box;
         .intr-info{
             border-radius: 4px;
             box-shadow: 0 0 6px rgba(156,156,156,0.34);
             margin: 10px 0 18px 0;
             padding: 12px 16px;
             font-size: 13px;
             line-height: 19px;
             text-align: justify;
             overflow: hidden;
             color: #666;
             p{
                width: 299px;
                overflow: hidden;
                img{
                  max-width: 100% !important;
                }
             }

         }
         .intr-banner{
             .van-swipe{
               overflow-x: hidden;
               overflow-y: inherit;
               height: 216px;
             }
            .my-swipe {
                .van-swipe-item {
                    height: 190px;
                    img{
                        width: 100%;
                        height: 190px;
                    }
                    .title{
                        width: 100%;
                        height: 22px;
                        font-size: 12px;
                        line-height: 22px;
                        text-align: center;
                        background: rgba(0,0,0,0.7);
                        position: relative;
                        left: 0;
                        top: -31px;
                        color: #fff;
                        font-weight: 600;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
               }
               /deep/.van-swipe__indicators{
                   .van-swipe__indicator--active{
                      width: 13px !important;
                      height: 4px;
                      border-radius: 2px;
                   }
                   .van-swipe__indicator{
                       width: 4px;
                       height: 4px;
                       border-radius: 2px;
                       background-color: #a2a2a2;
                   }
               }
            }
         }
      }
    }
    .classification{
        width: 100%;
        .classification-con{
            width: 100%;
            padding: 0 22px;
            box-sizing: border-box;
            .classification-swipe{
                 .van-swipe-item {
                    .classification-item{
                       padding: 16px;
                       border: 1px solid #d7d7d7;
                       border-radius: 5px;
                       margin-top: 12px;
                       min-height: 74px;
                       .title{
                           font-size: 13px;
                           font-weight: 600;
                           color: #333333;
                           margin-bottom: 10px;
                       }
                       .content{
                           font-size: 12px;
                           line-height: 18px;
                           text-align: justify;
                           word-break: break-all;
                           word-wrap: break-word;
                           .text{
                               color:#666666;
                               -webkit-line-clamp:3;
                               -webkit-box-orient:vertical;
                               overflow:hidden;
                           }
                           .more{
                             color: #4777b3;
                           }
                       }
                    }
               }

            }
        }
    }
    .relevant{
        width: 100%;
        .relevant-con{
            width: 100%;
            padding: 0 22px;
            box-sizing: border-box;
            .relevant-swipe{
                .van-swipe-item {
                   ul{
                       width: 100%;
                       li{
                           width: 100%;
                           height: 34px;
                           line-height: 34px;
                           font-size: 14px;
                           color: #666;
                           border-bottom: 1px dashed #ccc;
                            span{
                                display: inline-block;
                                width: 90%;
                                white-space:nowrap;
                                overflow:hidden;
                                text-overflow:ellipsis;
                            }
                           &::before {
                                content: "\02022";
                                margin-right: 8px;
                                color: #c3c3c3;
                                font-size: 24px;
                                vertical-align:top;
                            }

                       }
                   }
               }
            }
        }
    }
    .learning-camp{
        width: 100%;
        height: 172px;
        background: #000;
        overflow: hidden;
        .content{
            height: 118px;
            width: 92%;
            margin: 28px auto;
            display: flex;
            .qrcode{
                width: 118px;
                height: 118px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .info{
                flex: 1;
                margin-left: 20px;
                height: 118px;
                overflow: hidden;
                .title{
                    font-size: 14px;
                    font-weight: 600;
                    color: #fff;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
                .msg{
                    font-size: 13px;
                    line-height: 18px;
                    margin-top: 10px;
                    color: #a3a3a3;
                    text-align: justify;
                    word-break: break-all;
                    word-wrap:break-word;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 5;
                    overflow: hidden;
                }
            }
        }
    }
    .learning-camp-top{
        margin-top: 20px;
    }
}

.common-swipe-style{
  .my-swipe {
    .van-swipe-item {
        .classification-item{
            padding: 16px;
            border: 1px solid #d7d7d7;
            border-radius: 5px;
            margin-top: 12px;
            .title{
                font-size: 13px;
                font-weight: 500;
                color: #333333;
            }
            .content{
                font-size: 12px;
                line-height: 18px;
                .text{
                    color:#666666;
                    text-align: justify;
                }
                .more{
                    color: #4777b3;
                }
            }
        }
    }
    /deep/.van-swipe__indicators{
                position:relative;
                left: 50%;
                text-align: center;
                display: table;
            .van-swipe__indicator--active{
                width: 13px !important;
                height: 4px;
                border-radius: 2px;
            }
            .van-swipe__indicator{
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 2px;
                background-color: #a2a2a2;
            }
        }
    }

}

.m-t-10{
    margin-top: 10px;
}
.m-t-20{
    margin-top: 20px;
}
.m-b-20{
    margin-bottom: 20px;
}
.m-t-f-10{
  margin-top: -10px;
}

</style>



// WEBPACK FOOTER //
// src/views/article/topics.vue